







import { Component, Prop } from "vue-property-decorator";
import { WorkshopStatus } from "@/core/constants";

import AppVue from "@/AppVue.vue";

@Component
export default class RevStatusCpt extends AppVue {
  @Prop() text: string;
  @Prop() statusId: number;

  get badgeType() {
    return this.statusId === WorkshopStatus.Complete ? "success" : "primary";
  }
}
